import { Stack } from '@mui/system';
import { forwardRef } from 'react';
import classes from "../bt-chatbot.module.scss";
import AddConditionDialog from '../bt-nodes/condition/add-condition-dialog';
import AddGoogleSheetDialog from '../bt-nodes/google-sheets/add-google-sheet-dialog';
import AddQuestionDialog from '../bt-nodes/question/add-question-dialog';
import AddWebhookDialog from '../bt-nodes/webhook/add-webhook-dialog';
import BotSettings from './bot-settings';
import AddTriggerDialog from '../bt-nodes/trigger/add-trigger-dialog';
import AddAgentDialog from '../bt-nodes/agent/add-agent-dialog';
import AddLLMDialog from '../bt-nodes/LLM/add-llm-dialog';

type Props = {
    type: 'setCondition' | 'setQuestion' | 'setSettings' | 'setWebhook' | 'setGoogleSheet' | 'setStatus' | 'setTrigger' | 'setAgent' | 'setLLM';
    onClose: () => void;
    id?: string;
}

const BTChatbotModal = forwardRef<HTMLDivElement, Props>(({
    type,
    onClose,
    id,
}, ref) => {
    return (
        <Stack
            className={`${type === 'setSettings' ? classes.bt_popover_wrapper_for_settings : classes.bt_popover_wrapper} 
        ${classes.scrollContainer}`}
        >
            {type === 'setCondition' && <AddConditionDialog onClose={onClose} id={id} />}
            {type === 'setQuestion' && <AddQuestionDialog onClose={onClose} id={id} />}
            {type === 'setSettings' && <BotSettings onClose={onClose} />}
            {type === 'setWebhook' && <AddWebhookDialog onClose={onClose} id={id} />}
            {type === 'setGoogleSheet' && <AddGoogleSheetDialog onClose={onClose} id={id} />}
            {type === 'setTrigger' && <AddTriggerDialog onClose={onClose} id={id} />}
            {type === 'setAgent' && <AddAgentDialog open={true} onClose={onClose} id={id} />}
            {type === 'setLLM' && <AddLLMDialog onClose={onClose} id={id} />}
        </Stack>
    )
})

export default BTChatbotModal;

export const modalTextStyle = {
    fontSize: '13px',
    color: '#0A3750',
}